// Türkiye telefon numaralarını +90 formatına normalize eder.
// "0532 123 45 67", "532 123 45 67", "+90 532 123 45 67" gibi girdileri destekler.
export const formatPhoneTR = (rawPhone) => {
    if (!rawPhone) return null;

    let digits = rawPhone.replace(/\D/g, '');

    if (digits.startsWith('0090')) digits = digits.slice(4);
    if (digits.startsWith('90') && digits.length > 10) digits = digits.slice(2);
    if (digits.startsWith('0')) digits = digits.slice(1);

    if (digits.length !== 10) {
        return {
            display: rawPhone,
            tel: `+${digits}`,
            wa: digits
        };
    }

    const withCountry = `90${digits}`;

    return {
        display: `+90 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8, 10)}`,
        tel: `+${withCountry}`,
        wa: withCountry
    };
};
